import { render, staticRenderFns } from "./RomaBottomNav.vue?vue&type=template&id=ef876dd8&"
import script from "./RomaBottomNav.vue?vue&type=script&lang=js&"
export * from "./RomaBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./RomaBottomNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
